import 'react-dates/lib/css/_datepicker.css'
import 'react-dates/lib/initialize'
import { createGlobalStyle } from 'styled-components'
import { ITheme } from './index'

const DateStyles = createGlobalStyle`
  .CalendarMonth_caption {
    font-size: 17px;
  }
  .DayPickerNavigation__verticalDefault {
    height: 30px;
  }
  .DayPickerNavigation_button__verticalDefault {
    padding: 3px;
  }
  .DayPickerNavigation_svg__vertical {
    width: 24px;
    height: 24px;
  }
  .CalendarMonthGrid_month__hidden {
    display: none !important;
  }
  .DayPicker_transitionContainer__vertical {
    padding-bottom: 33px;
    height: 325px;
  }
   .CalendarDay__default:hover:not(.CalendarDay__blocked_out_of_range) {
    color: ${(props: ITheme) => props.theme.colors.datepicker.hoverLabel};
    background: ${(props: ITheme) => props.theme.colors.datepicker.hover};
    border: 1px double ${(props: ITheme) =>
      props.theme.colors.datepicker.hover};
  }
  
  .CalendarDay__highlighted_calendar:not(.CalendarDay__blocked_out_of_range) {
    background: #fff;
    border: 1px double ${(props: ITheme) =>
      props.theme.colors.datepicker.highlighted};
    color: ${(props: ITheme) => props.theme.colors.datepicker.highlighted};
    font-weight: bold;
  }
  
  .CalendarDay__default {
    outline: none;
  }
  .CalendarDay__default.CalendarDay__selected,
  .CalendarDay__default.CalendarDay__selected:active,
  .CalendarDay__default.CalendarDay__selected:hover,
  .CalendarDay__default.CalendarDay__blocked_calendar.CalendarDay__selected,
  .CalendarDay__default.CalendarDay__blocked_calendar.CalendarDay__selected:active,
  .CalendarDay__default.CalendarDay__blocked_calendar.CalendarDay__selected:hover {
    background: ${(props: ITheme) => props.theme.colors.datepicker.selected};
    border: 1px double ${(props: ITheme) =>
      props.theme.colors.datepicker.selected};
    color: #fff;
  }
  
  .CalendarDay__default.CalendarDay__selected_span,
  .CalendarDay__default.CalendarDay__selected_span:active,
  .CalendarDay__default.CalendarDay__hovered_span,
  .CalendarDay__default.CalendarDay__hovered_span:hover {
    background: ${(props: ITheme) =>
      props.theme.colors.datepicker.selectedSpan};
    border: 1px double ${(props: ITheme) =>
      props.theme.colors.datepicker.selected};
    color: #fff;
  }
  
  .CalendarDay__default.CalendarDay__selected_span:hover{
    background: ${(props: ITheme) =>
      props.theme.colors.datepicker.selectedSpanHover};
    border: 1px double ${(props: ITheme) =>
      props.theme.colors.datepicker.selected};
    color: #fff;
  }
  
  .DayPicker__withBorder {
    box-shadow: none;
  }
`
export default DateStyles
